var $b96bdf8456dd3b44$exports = {};
$b96bdf8456dd3b44$exports = {
    "removeButtonLabel": `\u{79FB}\u{9664}`,
    "removeDescription": `\u{6309} Delete \u{9375}\u{4EE5}\u{79FB}\u{9664}\u{6A19}\u{8A18}\u{3002}`
};


export {$b96bdf8456dd3b44$exports as default};
//# sourceMappingURL=zh-TW.mjs.map
